import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mapfre-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input() value = '';
  @Input() reducedHeight = false;
  valuePercent = '';
  constructor() {}

  ngOnInit() {
    this.valuePercent = (+this.value * 100).toString() + '%';
  }
}
